import { Api } from "./api"

const PATH = 'devise'
const ENDPOINTS = {
    Liste:'liste',
    Actives:'actives',
    Store:'store',
    Show:'show',
    Update:'update',
    Activate:'activate',
    Deactivate:'deactivate',
    SetDefault:'set-default',
    Delete:'delete',
    SyncRates:'sync-rates'
}

const getDevises = (params={},signal) => {
    const query = new URLSearchParams(params).toString()
    return Api.get(`${PATH}/${ENDPOINTS.Liste}${query ? `?${query}` : ''}`, signal)
}

const getActiveDevises = (signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Actives}`, signal)
}

const getDeviseDetails = (id,signal) => {
    return Api.get(`${PATH}/${ENDPOINTS.Show}/${id}`, signal)
}

const storeDevise = (payload,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Store}`,payload, signal)
}

const updateDevise = (id,payload,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Update}/${id}`,payload, signal)
}

const activateDevise = (id,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Activate}/${id}`,'', signal)
}

const deactivateDevise = (id,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.Deactivate}/${id}`,'', signal)
}

const setDefaultDevise = (id,signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.SetDefault}/${id}`,'', signal)
}

const deleteDevise = (id,signal) => {
    return Api.erase(`${PATH}/${ENDPOINTS.Delete}/${id}`, signal)
}

const syncRates = (signal) => {
    return Api.post(`${PATH}/${ENDPOINTS.SyncRates}`,'', signal)
}

const updatePreference = (deviseId,signal) => {
    return Api.post('devise-preference', JSON.stringify({ devise_id: deviseId }), signal)
}

export const DeviseApi={
    getDevises,
    getActiveDevises,
    getDeviseDetails,
    storeDevise,
    updateDevise,
    activateDevise,
    deactivateDevise,
    setDefaultDevise,
    deleteDevise,
    syncRates,
    updatePreference
}
